import { DefaultButton, PrimaryButton } from "@fluentui/react";
import React, { useEffect, useState } from "react";

import { Dialog, DialogFooter, DialogProps } from "./Dialog";

export interface AcceptanceDialogProps extends DialogProps {
    filename: string;
    onYesButtonClick(): void;
    onNoButtonClick(): void;
}

export const AcceptanceDialog: React.FunctionComponent<AcceptanceDialogProps> = (props: AcceptanceDialogProps) => {
    const [yesButtonText, setYesButtonText] = useState<string>("Yes");
    const [areButtonsDisabled, setAreButtonsDisabled] = useState<boolean>(false);

    useEffect(() => {
        if (!props.hidden) {
            setYesButtonText("Yes");
            setAreButtonsDisabled(false);
        }
    }, [props.hidden]);

    const onCancel = () => {
        props.onNoButtonClick();
    };

    const onYes = () => {
        setYesButtonText("Action in progress");
        setAreButtonsDisabled(true);
        props.onYesButtonClick();
    };

    return (
        <Dialog {...props}>
            <DialogFooter>
                <DefaultButton onClick={onCancel} text="No" disabled={areButtonsDisabled} />
                <PrimaryButton onClick={onYes} text={yesButtonText} disabled={areButtonsDisabled} />
            </DialogFooter>
        </Dialog>
    );
};
